import React from 'react';

const VoicePortabilityTable = (props) => {

    return (
        <table width="100%" className="green-table">
            <tbody>
                <tr>
                    <th colSpan="2">Local number portability class</th>
                    <th>Fee</th>
                </tr>
                <tr>
                    <td colSpan="2">Category A : Single PSTN without complex services</td>
                    <td>$15.00</td>
                </tr>
                <tr>
                    <td>Category C: Complex port</td>
                    <td>1 to 100 number range</td>
                    <td>$400.00</td>
                </tr>
                <tr>
                    <td>Category C: Complex port resubmit #</td>
                    <td>1 to 100 number range</td>
                    <td>$300.00</td>
                </tr>
            </tbody>
        </table>
    );

};

export default VoicePortabilityTable;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/VoicePortabilityTable.js